// extracted by extract-css-chunks-webpack-plugin
module.exports = {"warning":"#f8d13a","greyLight":"#b5b5b5","modalOpen":"Modal_modalOpen-2oCpj","pointer":"Modal_pointer-6cHns"};